import { type TooltipTriggerProps } from "@radix-ui/react-tooltip";

import { Tooltip } from "../Tooltip/Tooltip";
import { type WithTooltipProps } from "../Tooltip/withTooltip";

type TruncateTextProps = WithTooltipProps & {
  text: string;
  limit: number;
  ellipsis?: string;
  className?: string;
  tooltipClassName?: string;
  triggerProps?: Omit<TooltipTriggerProps, "children">;
};

export const TruncateText = ({
  text,
  limit,
  ellipsis = "...",
  className,
  tooltipClassName,
  tooltip,
}: TruncateTextProps) => {
  if (!text || typeof limit !== "number" || limit <= 0) {
    return <span className={className}>{text || "-"}</span>;
  }

  const shouldTruncate = text.length > limit;
  const displayText = shouldTruncate
    ? `${text.slice(0, limit)}${ellipsis}`
    : text;

  if (!tooltip || !shouldTruncate) {
    return <span className={className}>{displayText}</span>;
  }

  return (
    <Tooltip
      className={tooltipClassName}
      content={tooltip}
      triggerProps={{ asChild: false }}
    >
      <span className={className}>{displayText}</span>
    </Tooltip>
  );
};
